import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

const BLANK = { type: "mcq", text: "", options: ["", "", "", ""], correct_index: 0 };

export default function AdminQuestionPanel({ api, quiz }) {
  const [questions, setQuestions] = useState(quiz.questions || []);
  const [newQ, setNewQ] = useState(BLANK);
  const addQ = async () => {
    if (!newQ.text) return toast.error("Question text required");
    const body = { ...newQ, quiz_id: quiz.id };
    if (newQ.type === "tf") body.options = ["True", "False"];
    await api.post("/admin/questions", body);
    toast.success("Question added");
    const r = await api.get(`/quizzes/${quiz.id}`); setQuestions(r.data.questions);
    setNewQ(BLANK);
  };
  const delQ = async (qid) => { await api.delete(`/admin/questions/${qid}`);
    const r = await api.get(`/quizzes/${quiz.id}`); setQuestions(r.data.questions); };

  return (
    <>
      <h3 className="font-black text-xl">{quiz.title}</h3>
      <div className="sticker-card p-5 mt-3">
        <h4 className="font-black mb-3">Add question</h4>
        <select value={newQ.type} onChange={(e) => setNewQ({ ...newQ, type: e.target.value, options: e.target.value === "tf" ? ["True", "False"] : ["", "", "", ""], correct_index: 0 })}
          className="w-full px-3 py-2 rounded-lg border-[2px] border-[#374151] font-bold bg-white" data-testid="q-type">
          <option value="mcq">Multiple choice</option>
          <option value="tf">True / False</option>
        </select>
        <input placeholder="Question text" value={newQ.text} onChange={(e) => setNewQ({ ...newQ, text: e.target.value })} data-testid="q-text"
          className="mt-2 w-full px-3 py-2 rounded-lg border-[2px] border-[#374151] font-bold" />
        <div className="mt-2 space-y-2">
          {newQ.options.map((o, oi) => (
            <div key={oi} className="flex items-center gap-2">
              <input type="radio" checked={newQ.correct_index === oi} onChange={() => setNewQ({ ...newQ, correct_index: oi })} className="w-5 h-5" />
              {newQ.type === "mcq" ? (
                <input value={o} onChange={(e) => setNewQ({ ...newQ, options: newQ.options.map((v, j) => j === oi ? e.target.value : v) })}
                  placeholder={`Option ${oi + 1}`}
                  className="flex-1 px-3 py-2 rounded-lg border-[2px] border-[#374151] font-bold" />
              ) : <span className="font-black">{o}</span>}
            </div>
          ))}
        </div>
        <button onClick={addQ} data-testid="q-add"
          className="mt-3 px-5 py-2 rounded-full border-[3px] border-[#374151] bg-[var(--tp-primary)] text-white font-black shadow-[0_3px_0_0_#374151] active:translate-y-[3px] active:shadow-none">
          Add
        </button>
      </div>

      <div className="sticker mt-5">
        {questions.map((q, i) => (
          <div key={q.id} className={`p-4 ${i !== questions.length - 1 ? "border-b-[2px] border-slate-200" : ""} flex items-start gap-3`}>
            <div className="flex-1">
              <p className="font-black">{i + 1}. {q.text}</p>
              <p className="text-sm text-slate-500">{q.type.toUpperCase()} • correct: {q.options[q.correct_index]}</p>
            </div>
            <button onClick={() => delQ(q.id)} data-testid={`q-del-${q.id}`} className="text-[#FF4B4B]"><Trash2 size={16} strokeWidth={2.5} /></button>
          </div>
        ))}
        {questions.length === 0 && <p className="p-4 text-slate-500">No questions yet.</p>}
      </div>
    </>
  );
}
